var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Trail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 181,
    viewBox: "0 0 358 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357 181C357 181 337.115 161.203 323.316 149.588C295.347 126.045 276.635 116.18 245.496 96.6535C226.705 84.8701 216.594 77.4016 196.713 67.5686C161.992 50.3963 136.722 54.5475 102.631 36.1568C82.3583 25.2202 76.2475 8.374 53.8483 2.99993C39.0722 -0.545195 14.938 2.99993 14.938 2.99993H1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "13 13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Trail);
export default __webpack_public_path__ + "static/media/404-trail.4fd7fe718d7b30deb4f47e6b2a8d815f.svg";
export { ForwardRef as ReactComponent };